var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.08978 16.0833C5.67418 16.0833 5.31922 15.9361 5.02488 15.6418C4.73054 15.3474 4.58336 14.9925 4.58336 14.5769V3.99996H4.37503C4.19768 3.99996 4.04918 3.94014 3.92953 3.82048C3.80986 3.70083 3.75003 3.55233 3.75003 3.37498C3.75003 3.19764 3.80986 3.04914 3.92953 2.92948C4.04918 2.80982 4.19768 2.74998 4.37503 2.74998H7.50001C7.50001 2.54593 7.57186 2.37205 7.71555 2.22836C7.85925 2.08466 8.03312 2.01282 8.23718 2.01282H11.7628C11.9669 2.01282 12.1408 2.08466 12.2845 2.22836C12.4282 2.37205 12.5 2.54593 12.5 2.74998H15.625C15.8023 2.74998 15.9508 2.80982 16.0705 2.92948C16.1902 3.04914 16.25 3.19764 16.25 3.37498C16.25 3.55233 16.1902 3.70083 16.0705 3.82048C15.9508 3.94014 15.8023 3.99996 15.625 3.99996H15.4167V14.5769C15.4167 14.9925 15.2695 15.3474 14.9751 15.6418C14.6808 15.9361 14.3258 16.0833 13.9102 16.0833H6.08978ZM14.1667 3.99996H5.83334V14.5769C5.83334 14.6517 5.85738 14.7131 5.90547 14.7612C5.95355 14.8093 6.01499 14.8333 6.08978 14.8333H13.9102C13.985 14.8333 14.0465 14.8093 14.0946 14.7612C14.1426 14.7131 14.1667 14.6517 14.1667 14.5769V3.99996ZM7.83657 13.1666H9.08655V5.66663H7.83657V13.1666ZM10.9135 13.1666H12.1634V5.66663H10.9135V13.1666Z",
    fill: "#CCCCCC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.0f6b1e27b507841dddb67bd1d45c6391.svg";
export { ForwardRef as ReactComponent };